<template>
  <div class="app-container">
    <app-toolbar
      v-model="list.value"
      v-bind="toolbar"
      @remove="onRemove"
      @download="onDownload"
      @search="onSearch"
    />
    <app-list
      v-model="list.value"
      v-bind="list"
      @selection-change="onSelectionChange"
      ref="list"
    />
  </div>
</template>

<script>
import api from '@/api';
import appList from '@/components/AppList';
import appToolbar from '@/components/AppToolbar';

export default {
  name: 'business',
  components: { appList, appToolbar },
  data() {
    return {
      // 列表
      list: {
        props: [
          { type: 'selection', width: 55 },
          { label: '业务区', prop: 'businessName', width: 100, fixed: true },
          {
            label: '项目名称',
            prop: 'projectName',
            width: 300,
            fixed: true,
            showOverflowTooltip: true
          },
          { label: '业务类型', prop: 'businessType', width: 100, fixed: true },
          {
            label: '进度状态',
            prop: 'progressStatus',
            width: 100
          },
          { label: '预算', prop: 'budget', width: 100 },
          { label: '项目经理A', prop: 'projectManagerA', width: 100 },
          { label: '项目经理B', prop: 'projectManagerB', width: 100 },
          {
            label: '集成商',
            prop: 'integrators',
            width: 100,
            showOverflowTooltip: true
          },
          { label: '项目类型', prop: 'projectType', width: 100 },
          { label: '启动时间', prop: 'startDate', width: 100 },
          { label: '达产预期', prop: 'reachExpect', width: 100 },
          {
            label: '下步动作',
            prop: 'nextAction',
            width: 100,
            showOverflowTooltip: true
          },
          { label: '下步期限', prop: 'nextDeadline', width: 100 },
          { label: '客户经理', prop: 'clientManager', width: 100 },
          {
            label: '支撑工作描述',
            prop: 'jobsDescription',
            width: 200,
            showOverflowTooltip: true
          },
          {
            label: '复盘分析',
            prop: 'forexAnalysis',
            width: 200,
            showOverflowTooltip: true
          },
          {
            label: '业务区评价',
            prop: 'evaluate',
            width: 200,
            showOverflowTooltip: true
          },
          {
            label: '项目描述',
            prop: 'projectDescription',
            width: 200,
            showOverflowTooltip: true
          },
          {
            label: '备注',
            prop: 'remark',
            width: 100,
            showOverflowTooltip: true
          }
        ],
        value: null,
        selectedItems: []
      }
    };
  },
  computed: {
    // 工具栏
    toolbar() {
      const { selectedItems } = this.list;
      const { length } = selectedItems;
      const len = length > 0;
      let id;
      if (len) {
        id = selectedItems[0].id;
      }
      return {
        id,
        available: {
          create: true,
          update: len,
          remove: len
        }
      };
    }
  },
  methods: {
    // 选中多行
    onSelectionChange(e) {
      this.list.selectedItems = e;
    },
    // 移除后重新加载
    async onRemove() {
      try {
        this.loading = this.$loading({ target: '.app-main' });
        const { id } = this.toolbar;
        const { message } = await api.business.remove({ id });
        this.$notify({ title: '成功', message, type: 'success' });
        await this.$refs.list.getItems();
      } finally {
        this.loading.close();
      }
    },
    // 下载
    onDownload() {
      open('api/business/exportExcel', '_black');
    },
    // 搜索
    async onSearch(e) {
      this.list.search = e;
      await this.$refs.list.getItems();
    }
  }
};
</script>

<style lang="scss" scoped></style>
